/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Draggable from 'vuedraggable';
import RegistrationUnlayerEditor from 'shared/ui/components/editors/registration/RegistrationUnlayerEditor.vue';
import SwitcherMenu from 'shared/ui/components/navigation/SwitcherMenu.vue';
import PageDetailsModal from 'shared/ui/components/registrations/PageDetailsModal.vue';

const __vue_script__ = {
    name: 'AdvancedDesign',

    components: { Draggable, RegistrationUnlayerEditor, SwitcherMenu },

    props: {
        event: {
            type: Object,
            required: true
        },

        saveSpy: {
            type: Number,
            required: true
        },

        eventDetails: {
            type: Object,
            required: true,
        }
    },

    data() {
        return {
            currentPage: 'index',
            design: {},
            editorLoaded: false,
            isFullScreen: false,
            mergeTags: null,
            pageList: [],
            pageManagerVisible: false,
        };
    },

    async mounted() {
        await this.loadDesign();

        this.mergeTags = await this.getMergeTags();
    },

    methods: {
        async getMergeTags() {
            const groups = {};

            if (!this.eventDetails.sections) {
                return groups;
            }

            for (const [i, section] of this.eventDetails.sections.entries()) {
                if (section.type === 'editorial') {
                    continue;
                }

                groups[`${section.type}${i}`] = {
                    name: `${section.title.en} (section ${i + 1})`,
                    rules: {
                        repeat: {
                            name: 'Repeat for each entry',
                            before: `{{#each section_${i}}}`,
                            after: '{{/each}}'
                        }
                    },
                    mergeTags: await this.getFpTypeMergeTags(section.type)
                };
            }

            return groups;
        },

        async getFpTypeMergeTags(fpType) {
            const metadata = await this.$services.metadata.getMetadataForType(this.event.id, fpType, false, true);

            const result = {};

            for (const [key, definition] of Object.entries(metadata)) {
                if (definition?.kind === 'external') continue;

                result[key] = {
                    name: definition?.label || key,
                    value: `{{${key}}}`,
                    sample: definition?.default
                };
            }

            return result;
        },

        async loadDesign() {
            try {
                const data = await this.$services.pax.getAdvancedRegistration(this.event.id, this.currentPage);

                if (data) {
                    this.design = data.design || {};
                    if (!this.pageList?.length) {
                        this.pageList = data.pages;
                    }
                } else {
                    this.design = {};
                }
            } catch (e) {
                console.log('Failed to load design', e);
            }
        },

        /**
         * Callback when editor is loaded
         *
         * @param {Boolean} loaded editor is loaded or not
         */
        onEditorLoaded(loaded) {
            this.editorLoaded = loaded;
        },

        async pageSwitch(newValue) {
            this.currentPage = newValue;
            await this.loadDesign();
        },

        async saveDesign(params) {
            try {
                await this.$services.pax.setAdvancedRegistration(this.event.id, this.currentPage, params.design, params.html, this.pageList);
                this.$notify({
                    group: 'flashes',
                    text: this.$i18n.t('registration.configuration.messages.save_success').toString(),
                    type: 'success'
                });
            } catch (e) {
                console.log('Failed to save design', e);

                this.$notify({
                    group: 'flashes',
                    text: this.$i18n.t('registration.configuration.messages.save_failed').toString(),
                    type: 'error'
                });
            }
        },

        setPageManagerVisible(visible) {
            this.pageManagerVisible = visible;
        },

        /**
         * Switch the full screen mode.
         */
        toggleFullScreen() {
            this.isFullScreen = !this.isFullScreen;
        },

        addPage() {
            this.$modal.show(PageDetailsModal, {
                title: this.$t('registration.configuration.advanced_design_section.new_page'),
                onSave: (pageTitle) => {
                    this.pageList.push({ value: this.$utils.strings.toSnakeCase(pageTitle), label: pageTitle });
                }
            }, {
                classes: 'small',
                height: 'auto',
                clickToClose: false
            });
        },

        editPage(page) {
            this.$modal.show(PageDetailsModal, {
                title: this.$t('registration.configuration.advanced_design_section.edit_page'),
                value: page.label,
                onSave: (pageTitle) => {
                    const existingPage = this.pageList.find(p => p.value === page.value);
                    existingPage.label = pageTitle;
                }
            }, {
                classes: 'small',
                height: 'auto',
                clickToClose: false
            });
        },

        deletePage(page) {
            this.$modal.show('dialog', {
                title: this.$t('registration.configuration.advanced_design_section.delete_page'),
                text: this.$t('registration.configuration.advanced_design_section.delete_page_text'),
                buttons: [
                    {
                        title: this.$t('general.cancel'),
                        default: true,
                        class: 'btn'
                    },
                    {
                        title: this.$t('general.delete'),
                        handler: () => {
                            if (this.currentPage === page.value) {
                                this.pageSwitch('index');
                            }
                            this.pageList = this.pageList.filter(p => p.value !== page.value);
                            this.$modal.hide('dialog');
                        },
                        class: 'btn btn-danger'
                    }
                ]
            });
        },
    }
};

/* template */
var __vue_render__ = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "advanced-design" },
    [
      _c("switcher-menu", {
        attrs: { choices: _vm.pageList },
        on: { switch: _vm.pageSwitch },
        scopedSlots: _vm._u([
          {
            key: "actions",
            fn: function () {
              return [
                _c(
                  "a",
                  {
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.setPageManagerVisible(true)
                      },
                    },
                  },
                  [
                    _vm._v(
                      _vm._s(
                        _vm.$t(
                          "registration.configuration.advanced_design_section.manage_pages"
                        )
                      )
                    ),
                  ]
                ),
              ]
            },
            proxy: true,
          },
        ]),
        model: {
          value: _vm.currentPage,
          callback: function ($$v) {
            _vm.currentPage = $$v
          },
          expression: "currentPage",
        },
      }),
      _vm.pageManagerVisible && _vm.pageList.length
        ? _c(
            "div",
            { staticClass: "page-manager" },
            [
              _c("h4", { staticClass: "title" }, [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      "registration.configuration.advanced_design_section.pages"
                    )
                  )
                ),
              ]),
              _c("div", {
                staticClass: "close",
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.setPageManagerVisible(false)
                  },
                },
              }),
              _c(
                "draggable",
                {
                  staticClass: "page-list",
                  model: {
                    value: _vm.pageList,
                    callback: function ($$v) {
                      _vm.pageList = $$v
                    },
                    expression: "pageList",
                  },
                },
                _vm._l(_vm.pageList, function (page) {
                  return _c(
                    "div",
                    { key: page.value, staticClass: "page-item" },
                    [
                      _c("div", { staticClass: "drag-handler" }, [
                        _c("i", { staticClass: "icon-reorder" }),
                      ]),
                      _c("div", { staticClass: "page-name" }, [
                        _vm._v(_vm._s(page.label)),
                      ]),
                      _c("i", {
                        staticClass: "ic-edit",
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.editPage(page)
                          },
                        },
                      }),
                      page.value !== "index"
                        ? _c("i", {
                            staticClass: "ic-trash",
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.deletePage(page)
                              },
                            },
                          })
                        : _vm._e(),
                    ]
                  )
                }),
                0
              ),
              _c(
                "a",
                {
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.addPage()
                    },
                  },
                },
                [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "registration.configuration.advanced_design_section.add_page"
                      )
                    )
                  ),
                ]
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "div",
        {
          staticClass: "unlayer-wrapper",
          class: { "unlayer-fullscreen": _vm.isFullScreen },
        },
        [
          _vm.editorLoaded
            ? _c(
                "a",
                {
                  staticClass:
                    "btn btn-primary btn-icon single switch-fullscreen",
                  on: { click: _vm.toggleFullScreen },
                },
                [
                  _c("i", {
                    class: _vm.isFullScreen
                      ? "icon-resize-small"
                      : "icon-resize-full-screen",
                  }),
                ]
              )
            : _vm._e(),
          _c("registration-unlayer-editor", {
            attrs: {
              "save-spy": _vm.saveSpy,
              event: _vm.event,
              "merge-tags": _vm.mergeTags,
            },
            on: { loaded: _vm.onEditorLoaded, save: _vm.saveDesign },
            model: {
              value: _vm.design,
              callback: function ($$v) {
                _vm.design = $$v
              },
              expression: "design",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var __vue_staticRenderFns__ = []
__vue_render__._withStripped = true

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "apps/shared/src/ui/components/registrations/AdvancedDesign.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__